import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-clients-creations',
    templateUrl: './clients-creations.component.html',
    styleUrls: ['./clients-creations.component.scss'],
    imports: [TranslateModule],
})
export class ClientsCreationsComponent implements OnInit {
  showMagnetPopup: boolean = false;
  selectedMagnetImage: string = '';
  isPopupAnimating: boolean = false;
  isPopupClosing: boolean = false;
  private popupAutoCloseTimeout: any = null;
  currentTapHintIndex: number = 0;
  private tapHintInterval: any = null;
  magnetImages: string[] = ['e.webp', '1.webp', '4.webp', 'g.webp', 'b.webp', '2.webp', '3.webp', 'f.webp'];

  constructor() { }

  ngOnInit(): void {
    // this.startTapHintAnimation();
  }

    /**
   * Open magnet popup with zoom and flip animation
   */
    openMagnetPopup(imageName: string): void {
      // Clear any existing timeout
      if (this.popupAutoCloseTimeout) {
        clearTimeout(this.popupAutoCloseTimeout);
      }
  
      this.selectedMagnetImage = `../../assets/images/${imageName}`;
      this.showMagnetPopup = true;
      this.isPopupAnimating = true;
      this.isPopupClosing = false;
      
      // Start the zoom-in and flip animation sequence
      setTimeout(() => {
        this.isPopupAnimating = false;
      }, 50);
  
      // Auto-close after full animation completes
      this.popupAutoCloseTimeout = setTimeout(() => {
        this.autoClosePopup();
      }, 4000);
    }
  
    /**
     * Auto-close popup after animation completes
     */
    private autoClosePopup(): void {
      if (this.popupAutoCloseTimeout) {
        clearTimeout(this.popupAutoCloseTimeout);
        this.popupAutoCloseTimeout = null;
      }
      
      this.showMagnetPopup = false;
      this.selectedMagnetImage = '';
      this.isPopupAnimating = false;
      this.isPopupClosing = false;
    }
  
    /**
     * Manual close magnet popup (for click events)
     */
    closeMagnetPopup(): void {
      if (this.isPopupClosing) return; // Prevent multiple close calls
      
      this.isPopupClosing = true;
      
      // Immediate close for manual clicks
      this.autoClosePopup();
    }
  
    /**
     * Start the dynamic tap hint animation that cycles through magnet cards
     */
    private startTapHintAnimation(): void {
      // Start immediately with the first card
      this.currentTapHintIndex = 0;
      
      // Set up interval to cycle through cards every 2 seconds
      this.tapHintInterval = setInterval(() => {
        this.currentTapHintIndex = (this.currentTapHintIndex + 1) % this.magnetImages.length;
      }, 2000);
    }
  
    /**
     * Check if the current magnet should show the tap hint
     */
    shouldShowTapHint(index: number): boolean {
      return index === this.currentTapHintIndex;
    }

}
